import { DxDataGridComponent, DxFileUploaderComponent } from 'devextreme-angular';
import { ManualInputUpdateDto, ManualInputDynamicTable, CoreListElement, DynamicExcelParam, ErrorList, ManualInputDynamicTablePrams, ManualIds, MIds } from './../../../models/manualinput/ManualInput';
import { ManualInputService } from './../manual-input.service';
import { ManualInputDataField, DynamicInputTable, DyanmicInputUpdate } from './../../../models/manualinput/DataSetting';
import { Component, HostListener, inject, Inject, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
//npm install --save exceljs
//npm i file-saver
import * as FileSaver from 'file-saver';
const EXCEL_TYPE = 'application/octet-stream';
//npm install moment
import moment from 'moment';
import { } from 'jasmine'
import { HttpClient } from '@angular/common/http';
import { BaseService } from 'src/app/services/base.service';
import { FilePathCollection } from 'src/app/models/file/file-collection';
import { HelpService } from '../../help/help.service';
import { Title } from '@angular/platform-browser';
import { formatDate, Location } from '@angular/common';
import { AppDevNotifyComponent } from 'src/app/widgets/dev-notify-bar/dev-notify-bar.component';
import { FileExportService } from 'src/app/common/file-export-service';
import { TableParameterService } from 'src/app/services/table-parameter-service';
import { NavigateAssociates } from 'src/app/helpers/navigate-associates';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import { ActivatedRoute, Data } from '@angular/router';
import events from 'devextreme/events';
import dxCheckBox from 'devextreme/ui/check_box';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { BookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/bookmark-elements.operator';
import { DxDataGridBookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/dx-data-grid-bookmark-elements.operator';
import { UtilsService } from 'src/app/services/utils.service';
import { firstValueFrom } from 'rxjs';

@Component({
	selector: 'app-manual-input-update',
	templateUrl: './manual-input-update.component.html',
	styleUrls: ['./manual-input-update.component.scss'],
	standalone: false
})
export class ManualInputUpdateComponent implements OnInit {

	@ViewChild('editingDataGrid', { static: false }) dataGrid: DxDataGridComponent;

	valuesDataSource: DynamicInputTable[] = [];
	columnsDataSource: ManualInputDataField[] = [];
	columnsDataSourceNew: any;
	currentlySelectedTableId = 0;

	showInfoPopup = false;
	infoPopupMessage = '';
	showAddNewPopup = false;
	infPopupTitle = '';
	fitTableToPage = false;
	anyActiveFilters = false;

	addNewPopupTile = '';

	manualInputDynamicTablePramsData = new ManualInputDynamicTablePrams();
	manualInputDynamicTablePramsDataList: ManualInputDynamicTablePrams[] = [];

	manualInputEditingDto = new ManualInputUpdateDto();
	unsavedChanges = false;
	selectedInputs: ManualInputDynamicTable[] = [];
	coreListData: CoreListElement[] = [];
	dynamicTableGroup1Datasource: string[] = [];
	dynamicTableGroup2Datasource: string[] = [];
	dynamicTableGroup3Datasource: string[] = [];
	dynamicTableGroup4Datasource: string[] = [];
	dynamicTableGroup5Datasource: string[] = [];
	dynamicTableGroup6Datasource: string[] = [];
	dynamicTableGroup7Datasource: string[] = [];
	dynamicTableGroup8Datasource: string[] = [];
	dynamicTableGroup9Datasource: string[] = [];
	dynamicTableGroup10Datasource: string[] = [];
	dynamicTableGroup11Datasource: string[] = [];
	dynamicTableGroup12Datasource: string[] = [];
	dynamicTableGroup13Datasource: string[] = [];
	dynamicTableGroup14Datasource: string[] = [];
	dynamicTableGroup15Datasource: string[] = [];
	dynamicTableGroup16Datasource: string[] = [];
	dynamicTableGroup17Datasource: string[] = [];
	dynamicTableGroup18Datasource: string[] = [];
	dynamicTableGroup19Datasource: string[] = [];
	dynamicTableGroup20Datasource: string[] = [];
	dynamicTableGroup21Datasource: string[] = [];
	dynamicTableGroup22Datasource: string[] = [];
	dynamicTableGroup23Datasource: string[] = [];
	dynamicTableGroup24Datasource: string[] = [];
	dynamicTableGroup25Datasource: string[] = [];
	dynamicTableGroup26Datasource: string[] = [];
	dynamicTableGroup27Datasource: string[] = [];
	dynamicTableGroup28Datasource: string[] = [];
	dynamicTableGroup29Datasource: string[] = [];
	dynamicTableGroup30Datasource: string[] = [];

	dynamicTableMeasure1Datasource: string[] = [];
	dynamicTableMeasure2Datasource: string[] = [];
	dynamicTableMeasure3Datasource: string[] = [];
	dynamicTableMeasure4Datasource: string[] = [];
	dynamicTableMeasure5Datasource: string[] = [];
	dynamicTableMeasure6Datasource: string[] = [];
	dynamicTableMeasure7Datasource: string[] = [];
	dynamicTableMeasure8Datasource: string[] = [];
	dynamicTableMeasure9Datasource: string[] = [];
	dynamicTableMeasure10Datasource: string[] = [];
	dynamicTableMeasure11Datasource: string[] = [];
	dynamicTableMeasure12Datasource: string[] = [];
	dynamicTableMeasure13Datasource: string[] = [];
	dynamicTableMeasure14Datasource: string[] = [];
	dynamicTableMeasure15Datasource: string[] = [];
	dynamicTableMeasure16Datasource: string[] = [];
	dynamicTableMeasure17Datasource: string[] = [];
	dynamicTableMeasure18Datasource: string[] = [];
	dynamicTableMeasure19Datasource: string[] = [];
	dynamicTableMeasure20Datasource: string[] = [];
	dynamicTableMeasure21Datasource: string[] = [];
	dynamicTableMeasure22Datasource: string[] = [];
	dynamicTableMeasure23Datasource: string[] = [];
	dynamicTableMeasure24Datasource: string[] = [];
	dynamicTableMeasure25Datasource: string[] = [];
	dynamicTableMeasure26Datasource: string[] = [];
	dynamicTableMeasure27Datasource: string[] = [];
	dynamicTableMeasure28Datasource: string[] = [];
	dynamicTableMeasure29Datasource: string[] = [];
	dynamicTableMeasure30Datasource: string[] = [];

	newManualInput: ManualInputDynamicTable = new ManualInputDynamicTable();

	//excel import export field
	dynExcelParam: DynamicExcelParam = new DynamicExcelParam();
	dataValidationStarting = 300;
	public localID: string;


	searchTimeoutOption = 200;
	minSearchLengthOption = 0;
	dynamicHelpPageId: number;
	urlSelectedId: string;

	constructor(
		private manualInputService: ManualInputService,
		private http: HttpClient,
		private baseService: BaseService,
		private helpService: HelpService,
		private fileExpo: FileExportService,
		private titleService: Title,
		private tableParamService: TableParameterService,
		private _navigates: NavigateAssociates,
		private _location: Location,
		private route: ActivatedRoute,
		@Inject(LOCALE_ID) localID: string) { this.localID = localID; }
	auto: any;
	fileuploadUrl: string;
	ngOnInit() {
		this.auto = this.baseService.getNewOptions();
		delete this.auto['headers']['Content-Type'];
		this.auto['headers']['Accept'] = "multipart/form-data";
		this.fileuploadUrl = this.baseService.getCorrectUrl("FileUpload/UploadTemp");
		this.titleService.setTitle("Manual Data Input");
		this.urlSelectedId = this.route.snapshot.queryParamMap.get("id");
		this.loadPageInfo();
		this.loadExportSetting();
		//this.setDynamicHeight();
	}


	IsManuallyTableEnableDatabaseValidation: boolean = false;
	loadExportSetting() {

		this.fileExpo.WebSettings("ManuallyTableEnableDatabaseValidation").subscribe(result => {
			if (result != null && result.value.toLowerCase() == 'yes') {
				this.IsManuallyTableEnableDatabaseValidation = true;
			}
		}, err => {
			console.log(err);
		});
	}

	loadPageInfo(action: string = '', ids: MIds = { Id: [] }) {
		if (this.urlSelectedId != null && this.urlSelectedId != undefined) {
			this.currentlySelectedTableId = Number(this.urlSelectedId);
		}

		if (this.currentlySelectedTableId === 0) {
			this._location.replaceState(`manual-input/manual-input-update`);
			this.manualInputService.getDynamicTableData().subscribe(result => {

				this.columnsDataSource = result.fields;
				this.columnsDataSource.forEach(x => {
					if (x.fieldName === 'DynamicTableId') {
						this.columnsDataSource = this.columnsDataSource.filter(element => element !== x);
					}
					const firstChar = x.fieldName[0];
					const secPart = x.fieldName.slice(1, x.fieldName.length);
					x.fieldName = firstChar.toLowerCase() + secPart;
				});


				this.columnsDataSourceNew = [];
				this.columnsDataSource.forEach(element => {
					let dataCType = "";
					let format = "";
					if (element.fieldName.trim() == "DynamicTableGroup" || element.caption.trim() == "DynamicTableGroup") {
						this.columnsDataSourceNew.push({
							dataField: element.fieldName,
							caption: element.caption,
							groupIndex: 0,
							groupCellTemplate: "groupCellTemplate"
						});
					}
					else if (element.fieldName == "LastRunDate" || element.caption == "LastRunDate") {
						dataCType = "date";
						format = "MM.dd.yyyy HH:mm:ss";
						this.columnsDataSourceNew.push({
							dataField: element.fieldName,
							caption: element.caption,
							dataType: dataCType,
							format: format
						});
					}
					else if (element.fieldName == "ErrorLog" || element.caption == "ErrorLog") {
						element.color = "red-color";
					}

					else {
						this.columnsDataSourceNew.push({
							dataField: element.fieldName,
							caption: element.caption
						});
					}
				});
				this.valuesDataSource = result.values;

			});
		} else {
			this._location.replaceState(`manual-input/manual-input-update?id=${this.currentlySelectedTableId}`);
			this.loadDyanmicTableData();
		}
	}

	loadExtraValues() {
		this.manualInputEditingDto.values.forEach(EditingItem => {
			const selectItem = this.manualInputEditingDto.dynamicTableRow.find(x =>
				this.compareValues(x.fromOperation, EditingItem[x.fieldName], x.fromValue) && this.compareValues(x.toOperation, EditingItem[x.fieldName], x.toValue)
			);

			EditingItem.enableReadOnly = (selectItem == undefined || selectItem.userEdit == undefined || selectItem.userEdit == null ? true : selectItem.userEdit);//true mean disbale input and false mean enable input
			EditingItem.enableDelete = (selectItem == undefined || selectItem.enableDelete == undefined || selectItem.enableDelete == null ? true : selectItem.enableDelete);//true mean disbale input and false mean enable input
			// if (selectItem != null && selectItem != undefined) {
			// }
			// else {
			// }

		});

	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		//console.log('Grid content ready1:', evt,this.manualInputEditingDto.values);
		const filter = evt.component.getCombinedFilter();
		if (filter) {
			this.anyActiveFilters = true;
		} else {
			this.anyActiveFilters = false;
		}

		this.dxDataGridOperator.updateRowCount(evt.component);
		if (this.dataGrid && this.dataGrid.instance) {
			localStorage.setItem('grid-state-manual-upd', JSON.stringify(this.dataGrid.instance.state()));
		}
		//console.log('Grid content ready2:', evt);
	}

	pageTitle = "";
	selectionTableChanged(e) {
		this.currentlySelectedTableId = e.selectedRowsData[0].dynamicTableId;
		if (this.currentlySelectedTableId && this.currentlySelectedTableId != 0) {
			this._location.replaceState(`manual-input/manual-input-update?id=${this.currentlySelectedTableId}`);
		}
		this.SelectDynamicTableHelpId(this.currentlySelectedTableId);
		this.pageTitle = e.selectedRowsData[0].dynamicTableGroup + " - " + e.selectedRowsData[0].dynamicTableName;

		this.loadDyanmicTableData();
	}

	enableDisableDelete: boolean = true;
	loadDyanmicTableData(ids: MIds = { Id: [] }) {
		const $this = this;


		setTimeout(() => {
			$this.initializeBookmarks(this.currentlySelectedTableId);

		}, 500);

		this.manualInputService.getDynamicTableDataForEditing(this.currentlySelectedTableId).subscribe(result => {
			$this.manualInputEditingDto.dynamicTableRow = [];
			if (ids.Id != null && ids.Id.length > 0) {
				result.values.forEach(element => {
					let newItem = this.manualInputEditingDto.values.findIndex(x => x.id == element.id);
					if (newItem != undefined && newItem != null && newItem > -1) {
						this.manualInputEditingDto.values[newItem] = element;
					}
				});
			}
			else {
				this.manualInputEditingDto = result;
			}

			this.pageTitle = this.manualInputEditingDto.dynamicPageTitle[0].pageTitle;
			this.addNewPopupTile = "Add New " + this.manualInputEditingDto.dynamicPageTitle[0].dynamicTableName;

			if (this.manualInputEditingDto.dynamicPageTitle[0] != undefined && this.manualInputEditingDto.dynamicPageTitle[0].enableDelete != undefined
				&& this.manualInputEditingDto.dynamicPageTitle[0].enableDelete != null) {
				this.enableDisableDelete = this.manualInputEditingDto.dynamicPageTitle[0].enableDelete;//true mean disbale input and false mean enable input
			}

			$this.manualInputEditingDto = result;
			const dropDownFields = this.manualInputEditingDto.fields.filter(x => x.listId != null && x.listId != undefined).map((x) => {
				return x.listId;
			});
			this.manualInputEditingDto.fields.forEach(item => {

				if (item.field === 'DynamicTableGroup1' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup1 = item.defaultValueConvert;
				} else if (item.field === 'DynamicTableGroup2' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup2 = item.defaultValueConvert;
				} else if (item.field === 'DynamicTableGroup3' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup3 = item.defaultValueConvert;
				} else if (item.field === 'DynamicTableGroup4' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup4 = item.defaultValueConvert;
				} else if (item.field === 'DynamicTableGroup5' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup5 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableGroup6' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup6 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableGroup7' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup7 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableGroup8' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup8 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableGroup9' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup9 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableGroup10' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup10 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableGroup11' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup11 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableGroup12' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup12 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableGroup13' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup13 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableGroup14' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup14 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableGroup15' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup15 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableGroup16' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup16 = item.defaultValueConvert;
				} else if (item.field === 'DynamicTableGroup17' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup17 = item.defaultValueConvert;
				} else if (item.field === 'DynamicTableGroup18' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup18 = item.defaultValueConvert;
				} else if (item.field === 'DynamicTableGroup19' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup19 = item.defaultValueConvert;
				} else if (item.field === 'DynamicTableGroup20' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup20 = item.defaultValueConvert;
				}else if (item.field === 'DynamicTableGroup21' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup21 = item.defaultValueConvert;
				}else if (item.field === 'DynamicTableGroup22' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup22 = item.defaultValueConvert;
				}else if (item.field === 'DynamicTableGroup23' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup23 = item.defaultValueConvert;
				}else if (item.field === 'DynamicTableGroup24' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup24 = item.defaultValueConvert;
				}else if (item.field === 'DynamicTableGroup25' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup25 = item.defaultValueConvert;
				}else if (item.field === 'DynamicTableGroup26' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup26 = item.defaultValueConvert;
				}else if (item.field === 'DynamicTableGroup27' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup27 = item.defaultValueConvert;
				}else if (item.field === 'DynamicTableGroup28' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup28 = item.defaultValueConvert;
				}else if (item.field === 'DynamicTableGroup29' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup29 = item.defaultValueConvert;
				}else if (item.field === 'DynamicTableGroup30' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableGroup30 = item.defaultValueConvert;
				}

				else if (item.field === 'DynamicTableMeasure1' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure1 = item.defaultValueConvert;
				} else if (item.field === 'DynamicTableMeasure2' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure2 = item.defaultValueConvert;
				} else if (item.field === 'DynamicTableMeasure3' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure3 = item.defaultValueConvert;
				} else if (item.field === 'DynamicTableMeasure4' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure4 = item.defaultValueConvert;
				} else if (item.field === 'DynamicTableMeasure5' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure5 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure6' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure6 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure7' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure7 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure8' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure8 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure9' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure9 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure10' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure10 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure11' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure11 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure12' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure12 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure13' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure13 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure14' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure14 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure15' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure15 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure16' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure16 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure17' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure17 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure18' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure18 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure19' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure19 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure20' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure20 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure21' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure21 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure22' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure22 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure23' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure23 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure24' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure24 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure25' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure25 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure26' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure26 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure27' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure27 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure28' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure28 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure29' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure29 = item.defaultValueConvert;
				}
				else if (item.field === 'DynamicTableMeasure30' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableMeasure30 = item.defaultValueConvert;
				}

				if (item.field === 'DynamicTableDateGroup1' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableDateGroup1 = this.convertToLocalDate(item.defaultValueConvert);
				} else if (item.field === 'DynamicTableDateGroup2' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableDateGroup2 = this.convertToLocalDate(item.defaultValueConvert);
				} else if (item.field === 'DynamicTableDateGroup3' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableDateGroup3 = this.convertToLocalDate(item.defaultValueConvert);
				} else if (item.field === 'DynamicTableDateGroup4' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableDateGroup4 = this.convertToLocalDate(item.defaultValueConvert);
				} else if (item.field === 'DynamicTableDateGroup5' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableDateGroup5 = this.convertToLocalDate(item.defaultValueConvert);
				}
				else if (item.field === 'DynamicTableDateGroup6' && item.defaultValueConvert != null && item.defaultValueConvert != undefined) {
					this.newManualInput.dynamicTableDateGroup6 = this.convertToLocalDate(item.defaultValueConvert);
				}
			});

			if (dropDownFields != null && dropDownFields.length > 0) {
				this.manualInputService.getListDataSourceForField(dropDownFields).subscribe(res => {
					this.coreListData = res;

					const editingDtoFiltered = $this.manualInputEditingDto.fields.filter(x => x.listId != null && x.listId != undefined);

					editingDtoFiltered.forEach(x => {
						const correspondingListValues = res.filter(y => y.listId === x.listId).map(z => {
							return z.listElement;
						});

						if (x.field === 'dynamicTableGroup1') {
							this.dynamicTableGroup1Datasource = correspondingListValues;
						} else if (x.field === 'dynamicTableGroup2') {
							this.dynamicTableGroup2Datasource = correspondingListValues;
						} else if (x.field === 'dynamicTableGroup3') {
							this.dynamicTableGroup3Datasource = correspondingListValues;
						} else if (x.field === 'dynamicTableGroup4') {
							this.dynamicTableGroup4Datasource = correspondingListValues;
						} else if (x.field === 'dynamicTableGroup5') {
							this.dynamicTableGroup5Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableGroup6') {
							this.dynamicTableGroup6Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableGroup7') {
							this.dynamicTableGroup7Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableGroup8') {
							this.dynamicTableGroup8Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableGroup9') {
							this.dynamicTableGroup9Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableGroup10') {
							this.dynamicTableGroup10Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableGroup11') {
							this.dynamicTableGroup11Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableGroup12') {
							this.dynamicTableGroup12Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableGroup13') {
							this.dynamicTableGroup13Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableGroup14') {
							this.dynamicTableGroup14Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableGroup15') {
							this.dynamicTableGroup15Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableGroup16') {
							this.dynamicTableGroup16Datasource = correspondingListValues;
						} else if (x.field === 'dynamicTableGroup17') {
							this.dynamicTableGroup17Datasource = correspondingListValues;
						} else if (x.field === 'dynamicTableGroup18') {
							this.dynamicTableGroup18Datasource = correspondingListValues;
						} else if (x.field === 'dynamicTableGroup19') {
							this.dynamicTableGroup19Datasource = correspondingListValues;
						} else if (x.field === 'dynamicTableGroup20') {
							this.dynamicTableGroup20Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableGroup21') {
							this.dynamicTableGroup21Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableGroup22') {
							this.dynamicTableGroup22Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableGroup23') {
							this.dynamicTableGroup23Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableGroup24') {
							this.dynamicTableGroup24Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableGroup25') {
							this.dynamicTableGroup25Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableGroup26') {
							this.dynamicTableGroup26Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableGroup27') {
							this.dynamicTableGroup27Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableGroup28') {
							this.dynamicTableGroup28Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableGroup29') {
							this.dynamicTableGroup29Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableGroup30') {
							this.dynamicTableGroup30Datasource = correspondingListValues;
						}

						else if (x.field === 'dynamicTableMeasure1') {
							this.dynamicTableMeasure1Datasource = correspondingListValues;
						} else if (x.field === 'dynamicTableMeasure2') {
							this.dynamicTableMeasure2Datasource = correspondingListValues;
						} else if (x.field === 'dynamicTableMeasure3') {
							this.dynamicTableMeasure3Datasource = correspondingListValues;
						} else if (x.field === 'dynamicTableMeasure4') {
							this.dynamicTableMeasure4Datasource = correspondingListValues;
						} else if (x.field === 'dynamicTableMeasure5') {
							this.dynamicTableMeasure5Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure6') {
							this.dynamicTableMeasure6Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure7') {
							this.dynamicTableMeasure7Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure8') {
							this.dynamicTableMeasure8Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure9') {
							this.dynamicTableMeasure9Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure10') {
							this.dynamicTableMeasure10Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure11') {
							this.dynamicTableMeasure11Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure12') {
							this.dynamicTableMeasure12Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure13') {
							this.dynamicTableMeasure13Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure14') {
							this.dynamicTableMeasure14Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure15') {
							this.dynamicTableMeasure15Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure16') {
							this.dynamicTableMeasure16Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure17') {
							this.dynamicTableMeasure17Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure18') {
							this.dynamicTableMeasure18Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure19') {
							this.dynamicTableMeasure19Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure20') {
							this.dynamicTableMeasure20Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure21') {
							this.dynamicTableMeasure21Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure22') {
							this.dynamicTableMeasure22Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure23') {
							this.dynamicTableMeasure23Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure24') {
							this.dynamicTableMeasure24Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure25') {
							this.dynamicTableMeasure25Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure26') {
							this.dynamicTableMeasure26Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure27') {
							this.dynamicTableMeasure27Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure28') {
							this.dynamicTableMeasure28Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure29') {
							this.dynamicTableMeasure29Datasource = correspondingListValues;
						}
						else if (x.field === 'dynamicTableMeasure30') {
							this.dynamicTableMeasure30Datasource = correspondingListValues;
						}
					});

				}
				);
			}

			$this.manualInputEditingDto.fields.forEach(x => {
				if (x.field === 'DynamicTableId') {
					$this.manualInputEditingDto.fields = $this.manualInputEditingDto.fields.filter(element => element !== x);
				}

				const firstChar = x.field[0];
				const secPart = x.field.slice(1, x.field.length);

				x.field = firstChar.toLowerCase() + secPart;
			});

			$this.loadExtraValues();
			setTimeout(() => {
				$this.bookmarksGroup.applyDefaultBookmark();

			}, 500);

			$this.setDynamicHeight();
		}, (err) => {
			AppDevNotifyComponent.ErrorMessage("Sorry, something went wrong. Please try after some time again.");
		});
	}

	convertToLocalDate(responseDate: string): Date {
		try {
			if (responseDate != null) {
				responseDate = moment(responseDate, "DD/MM/YYYY").format();
				return new Date(responseDate);
			} else {
				return null;
			}
		} catch (error) {
			return null;
		}
	}

	goBack() {
		this.currentlySelectedTableId = 0;
		this.urlSelectedId = null;
		this.manualInputEditingDto = new ManualInputUpdateDto();
		this.loadPageInfo();
	}

	changeFitToPageStatus() {
		this.fitTableToPage = !this.fitTableToPage;


		let currentState = this.dataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dataGrid.instance.state(currentState);
	}

	changeActiveFiltersStatus() {
		if (this.anyActiveFilters) {
			this.anyActiveFilters = !this.anyActiveFilters;
			this.dataGrid.instance.clearFilter();
		}
	}

	canEdit(item: any): boolean {
		const dataField = item.column.dataField;
		const correspondingColumn = this.manualInputEditingDto.fields.find(x => x.field === dataField);
		if (item.data.enableReadOnly != undefined && item.data.enableReadOnly != null && !item.data.enableReadOnly) {
			return item.data.enableReadOnly;
		}
		else if (correspondingColumn && correspondingColumn.userEdit) {
			return true;
		}
		return false;
	}

	saveAllChanges() {
		if (this.unsavedChanges) {

			let updateItemIds: MIds = { Id: [] };
			this.manualInputDynamicTablePramsDataList = [];
			this.manualInputEditingDto.values.forEach(item => {
				let dataManul = new ManualInputDynamicTablePrams();
				if (item.modfy) {
					updateItemIds.Id.push(item.id);
					dataManul.dynamicTableId = item.dynamicTableId;
					dataManul.dynamicTableGroup1 = item.dynamicTableGroup1 === '' ? null : item.dynamicTableGroup1;
					dataManul.dynamicTableGroup2 = item.dynamicTableGroup2 === '' ? null : item.dynamicTableGroup2;
					dataManul.dynamicTableGroup3 = item.dynamicTableGroup3 === '' ? null : item.dynamicTableGroup3;
					dataManul.dynamicTableGroup4 = item.dynamicTableGroup4 === '' ? null : item.dynamicTableGroup4;
					dataManul.dynamicTableGroup5 = item.dynamicTableGroup5 === '' ? null : item.dynamicTableGroup5;
					dataManul.dynamicTableGroup6 = item.dynamicTableGroup6 === '' ? null : item.dynamicTableGroup6;
					dataManul.dynamicTableGroup7 = item.dynamicTableGroup7 === '' ? null : item.dynamicTableGroup7;
					dataManul.dynamicTableGroup8 = item.dynamicTableGroup8 === '' ? null : item.dynamicTableGroup8;
					dataManul.dynamicTableGroup9 = item.dynamicTableGroup9 === '' ? null : item.dynamicTableGroup9;
					dataManul.dynamicTableGroup10 = item.dynamicTableGroup10 === '' ? null : item.dynamicTableGroup10;
					dataManul.dynamicTableGroup11 = item.dynamicTableGroup11 === '' ? null : item.dynamicTableGroup11;
					dataManul.dynamicTableGroup12 = item.dynamicTableGroup12 === '' ? null : item.dynamicTableGroup12;
					dataManul.dynamicTableGroup13 = item.dynamicTableGroup13 === '' ? null : item.dynamicTableGroup13;
					dataManul.dynamicTableGroup14 = item.dynamicTableGroup14 === '' ? null : item.dynamicTableGroup14;
					dataManul.dynamicTableGroup15 = item.dynamicTableGroup15 === '' ? null : item.dynamicTableGroup15;
					dataManul.dynamicTableGroup16 = item.dynamicTableGroup16 === '' ? null : item.dynamicTableGroup16;
					dataManul.dynamicTableGroup17 = item.dynamicTableGroup17 === '' ? null : item.dynamicTableGroup17;
					dataManul.dynamicTableGroup18 = item.dynamicTableGroup18 === '' ? null : item.dynamicTableGroup18;
					dataManul.dynamicTableGroup19 = item.dynamicTableGroup19 === '' ? null : item.dynamicTableGroup19;
					dataManul.dynamicTableGroup20 = item.dynamicTableGroup20 === '' ? null : item.dynamicTableGroup20;
					dataManul.dynamicTableGroup21 = item.dynamicTableGroup21 === '' ? null : item.dynamicTableGroup21;
					dataManul.dynamicTableGroup22 = item.dynamicTableGroup22 === '' ? null : item.dynamicTableGroup22;
					dataManul.dynamicTableGroup23 = item.dynamicTableGroup23 === '' ? null : item.dynamicTableGroup23;
					dataManul.dynamicTableGroup24 = item.dynamicTableGroup24 === '' ? null : item.dynamicTableGroup24;
					dataManul.dynamicTableGroup25 = item.dynamicTableGroup25 === '' ? null : item.dynamicTableGroup25;
					dataManul.dynamicTableGroup26 = item.dynamicTableGroup26 === '' ? null : item.dynamicTableGroup26;
					dataManul.dynamicTableGroup27 = item.dynamicTableGroup27 === '' ? null : item.dynamicTableGroup27;
					dataManul.dynamicTableGroup28 = item.dynamicTableGroup28 === '' ? null : item.dynamicTableGroup28;
					dataManul.dynamicTableGroup29 = item.dynamicTableGroup29 === '' ? null : item.dynamicTableGroup29;
					dataManul.dynamicTableGroup30 = item.dynamicTableGroup30 === '' ? null : item.dynamicTableGroup30				

					dataManul.dynamicTableMeasure1 = item.dynamicTableMeasure1;
					dataManul.dynamicTableMeasure2 = item.dynamicTableMeasure2;
					dataManul.dynamicTableMeasure3 = item.dynamicTableMeasure3;
					dataManul.dynamicTableMeasure4 = item.dynamicTableMeasure4;
					dataManul.dynamicTableMeasure5 = item.dynamicTableMeasure5;
					dataManul.dynamicTableMeasure6 = item.dynamicTableMeasure6;
					dataManul.dynamicTableMeasure7 = item.dynamicTableMeasure7;
					dataManul.dynamicTableMeasure8 = item.dynamicTableMeasure8;
					dataManul.dynamicTableMeasure9 = item.dynamicTableMeasure9;
					dataManul.dynamicTableMeasure10 = item.dynamicTableMeasure10;
					dataManul.dynamicTableMeasure11 = item.dynamicTableMeasure11;
					dataManul.dynamicTableMeasure12 = item.dynamicTableMeasure12;
					dataManul.dynamicTableMeasure13 = item.dynamicTableMeasure13;
					dataManul.dynamicTableMeasure14 = item.dynamicTableMeasure14;
					dataManul.dynamicTableMeasure15 = item.dynamicTableMeasure15;
					dataManul.dynamicTableMeasure16 = item.dynamicTableMeasure16;
					dataManul.dynamicTableMeasure17 = item.dynamicTableMeasure17;
					dataManul.dynamicTableMeasure18 = item.dynamicTableMeasure18;
					dataManul.dynamicTableMeasure19 = item.dynamicTableMeasure19;
					dataManul.dynamicTableMeasure20 = item.dynamicTableMeasure20;
					dataManul.dynamicTableMeasure21 = item.dynamicTableMeasure21;
					dataManul.dynamicTableMeasure22 = item.dynamicTableMeasure22;
					dataManul.dynamicTableMeasure23 = item.dynamicTableMeasure23;
					dataManul.dynamicTableMeasure24 = item.dynamicTableMeasure24;
					dataManul.dynamicTableMeasure25 = item.dynamicTableMeasure25;
					dataManul.dynamicTableMeasure26 = item.dynamicTableMeasure26;
					dataManul.dynamicTableMeasure27 = item.dynamicTableMeasure27;
					dataManul.dynamicTableMeasure28 = item.dynamicTableMeasure28;
					dataManul.dynamicTableMeasure29 = item.dynamicTableMeasure29;
					dataManul.dynamicTableMeasure30 = item.dynamicTableMeasure30;


					dataManul.dynamicTableDateGroup1 = (item.dynamicTableDateGroup1 == null || item.dynamicTableDateGroup1 == undefined ? null :
						formatDate(item.dynamicTableDateGroup1, "yyyy-MM-dd HH:mm:ss", this.localID));
					dataManul.dynamicTableDateGroup2 = (item.dynamicTableDateGroup2 == null || item.dynamicTableDateGroup2 == undefined ? null :
						formatDate(item.dynamicTableDateGroup2, "yyyy-MM-dd HH:mm:ss", this.localID));
					dataManul.dynamicTableDateGroup3 = (item.dynamicTableDateGroup3 == null || item.dynamicTableDateGroup3 == undefined ? null :
						formatDate(item.dynamicTableDateGroup3, "yyyy-MM-dd HH:mm:ss", this.localID));
					dataManul.dynamicTableDateGroup4 = (item.dynamicTableDateGroup4 == null || item.dynamicTableDateGroup4 == undefined ? null :
						formatDate(item.dynamicTableDateGroup4, "yyyy-MM-dd HH:mm:ss", this.localID));
					dataManul.dynamicTableDateGroup5 = (item.dynamicTableDateGroup5 == null || item.dynamicTableDateGroup5 == undefined ? null :
						formatDate(item.dynamicTableDateGroup5, "yyyy-MM-dd HH:mm:ss", this.localID));
					dataManul.dynamicTableDateGroup6 = (item.dynamicTableDateGroup6 == null || item.dynamicTableDateGroup6 == undefined ? null :
						formatDate(item.dynamicTableDateGroup6, "yyyy-MM-dd HH:mm:ss", this.localID));

					this.manualInputDynamicTablePramsDataList.push(dataManul);
				}
			});

			this.manualInputService.updateManualInputs(this.manualInputDynamicTablePramsDataList).subscribe(result => {

				this.infoPopupMessage = 'Changes Saved Successfully!';
				this.infPopupTitle = 'Saved';
				this.showInfoPopup = true;

				this.unsavedChanges = false;
				this.loadPageInfo("SaveReload", updateItemIds);
				setTimeout(() => {
					this.changeInfoPopupStatusFalse();
				}, 3000);

			});
		} else {
			this.showInfoPopup = true;
			this.infoPopupMessage = 'No changes have been done yet.';
			this.infPopupTitle = 'Warning';

			setTimeout(() => {
				this.changeInfoPopupStatusFalse();
			}, 3000);
		}
	}

	undoAllChanges() {
		if (this.unsavedChanges) {
			this.loadPageInfo();
			this.unsavedChanges = false;
		} else {
			this.showInfoPopup = true;
			this.infoPopupMessage = 'No changes have been done yet.';
			this.infPopupTitle = 'Warning';

			setTimeout(() => {
				this.changeInfoPopupStatus();
			}, 3000);
		}
	}



	gridSelectionChanged(data: any) {
		this.selectedInputs = [];
		if (data && data.selectedRowKeys && data.selectedRowKeys.length > 0) {
			data.selectedRowKeys.forEach(element => {
				if (!this.selectedInputs.includes(element)) {
					this.selectedInputs.push(element);

				}
			});
		}
	}

	gridRowUpdated(e) {
		e.data.modfy = true;
		this.unsavedChanges = true;
	}

	changeInfoPopupStatus() {
		this.showInfoPopup = !this.showInfoPopup;
	}

	changeInfoPopupStatusFalse() {
		this.showInfoPopup = false;
	}
	changeAddNewPopupStatus() {
		this.showAddNewPopup = !this.showAddNewPopup;
	}

	addNewInput() {

		this.newManualInput.dynamicTableId = this.currentlySelectedTableId;

		this.manualInputDynamicTablePramsData.dynamicTableId = this.newManualInput.dynamicTableId;
		this.manualInputDynamicTablePramsData.dynamicTableGroup1 = this.newManualInput.dynamicTableGroup1;
		this.manualInputDynamicTablePramsData.dynamicTableGroup2 = this.newManualInput.dynamicTableGroup2;
		this.manualInputDynamicTablePramsData.dynamicTableGroup3 = this.newManualInput.dynamicTableGroup3;
		this.manualInputDynamicTablePramsData.dynamicTableGroup4 = this.newManualInput.dynamicTableGroup4;
		this.manualInputDynamicTablePramsData.dynamicTableGroup5 = this.newManualInput.dynamicTableGroup5;
		this.manualInputDynamicTablePramsData.dynamicTableGroup6 = this.newManualInput.dynamicTableGroup6;
		this.manualInputDynamicTablePramsData.dynamicTableGroup7 = this.newManualInput.dynamicTableGroup7;
		this.manualInputDynamicTablePramsData.dynamicTableGroup8 = this.newManualInput.dynamicTableGroup8;
		this.manualInputDynamicTablePramsData.dynamicTableGroup9 = this.newManualInput.dynamicTableGroup9;
		this.manualInputDynamicTablePramsData.dynamicTableGroup10 = this.newManualInput.dynamicTableGroup10;
		this.manualInputDynamicTablePramsData.dynamicTableGroup11 = this.newManualInput.dynamicTableGroup11;
		this.manualInputDynamicTablePramsData.dynamicTableGroup12 = this.newManualInput.dynamicTableGroup12;
		this.manualInputDynamicTablePramsData.dynamicTableGroup13 = this.newManualInput.dynamicTableGroup13;
		this.manualInputDynamicTablePramsData.dynamicTableGroup14 = this.newManualInput.dynamicTableGroup14;
		this.manualInputDynamicTablePramsData.dynamicTableGroup15 = this.newManualInput.dynamicTableGroup15;
		this.manualInputDynamicTablePramsData.dynamicTableGroup16 = this.newManualInput.dynamicTableGroup16;
		this.manualInputDynamicTablePramsData.dynamicTableGroup17 = this.newManualInput.dynamicTableGroup17;
		this.manualInputDynamicTablePramsData.dynamicTableGroup18 = this.newManualInput.dynamicTableGroup18;
		this.manualInputDynamicTablePramsData.dynamicTableGroup19 = this.newManualInput.dynamicTableGroup19;
		this.manualInputDynamicTablePramsData.dynamicTableGroup20 = this.newManualInput.dynamicTableGroup20;
		this.manualInputDynamicTablePramsData.dynamicTableGroup21 = this.newManualInput.dynamicTableGroup21;
		this.manualInputDynamicTablePramsData.dynamicTableGroup22 = this.newManualInput.dynamicTableGroup22;
		this.manualInputDynamicTablePramsData.dynamicTableGroup23 = this.newManualInput.dynamicTableGroup23;
		this.manualInputDynamicTablePramsData.dynamicTableGroup24 = this.newManualInput.dynamicTableGroup24;
		this.manualInputDynamicTablePramsData.dynamicTableGroup25 = this.newManualInput.dynamicTableGroup25;
		this.manualInputDynamicTablePramsData.dynamicTableGroup26 = this.newManualInput.dynamicTableGroup26;
		this.manualInputDynamicTablePramsData.dynamicTableGroup27 = this.newManualInput.dynamicTableGroup27;
		this.manualInputDynamicTablePramsData.dynamicTableGroup28 = this.newManualInput.dynamicTableGroup28;
		this.manualInputDynamicTablePramsData.dynamicTableGroup29 = this.newManualInput.dynamicTableGroup29;
		this.manualInputDynamicTablePramsData.dynamicTableGroup30 = this.newManualInput.dynamicTableGroup30;

		this.manualInputDynamicTablePramsData.dynamicTableMeasure1 = this.newManualInput.dynamicTableMeasure1;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure2 = this.newManualInput.dynamicTableMeasure2;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure3 = this.newManualInput.dynamicTableMeasure3;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure4 = this.newManualInput.dynamicTableMeasure4;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure5 = this.newManualInput.dynamicTableMeasure5;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure6 = this.newManualInput.dynamicTableMeasure6;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure7 = this.newManualInput.dynamicTableMeasure7;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure8 = this.newManualInput.dynamicTableMeasure8;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure9 = this.newManualInput.dynamicTableMeasure9;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure10 = this.newManualInput.dynamicTableMeasure10;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure11 = this.newManualInput.dynamicTableMeasure11;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure12 = this.newManualInput.dynamicTableMeasure12;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure13 = this.newManualInput.dynamicTableMeasure13;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure14 = this.newManualInput.dynamicTableMeasure14;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure15 = this.newManualInput.dynamicTableMeasure15;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure16 = this.newManualInput.dynamicTableMeasure16;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure17 = this.newManualInput.dynamicTableMeasure17;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure18 = this.newManualInput.dynamicTableMeasure18;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure19 = this.newManualInput.dynamicTableMeasure19;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure20 = this.newManualInput.dynamicTableMeasure20;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure21 = this.newManualInput.dynamicTableMeasure21;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure22 = this.newManualInput.dynamicTableMeasure22;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure23 = this.newManualInput.dynamicTableMeasure23;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure24 = this.newManualInput.dynamicTableMeasure24;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure25 = this.newManualInput.dynamicTableMeasure25;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure26 = this.newManualInput.dynamicTableMeasure26;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure27 = this.newManualInput.dynamicTableMeasure27;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure28 = this.newManualInput.dynamicTableMeasure28;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure29 = this.newManualInput.dynamicTableMeasure29;
		this.manualInputDynamicTablePramsData.dynamicTableMeasure30 = this.newManualInput.dynamicTableMeasure30;

		this.manualInputDynamicTablePramsData.dynamicTableDateGroup1 = (this.newManualInput.dynamicTableDateGroup1 == null || this.newManualInput.dynamicTableDateGroup1 == undefined ? null :
			formatDate(this.newManualInput.dynamicTableDateGroup1, "yyyy-MM-dd HH:mm:ss", this.localID));
		this.manualInputDynamicTablePramsData.dynamicTableDateGroup2 = (this.newManualInput.dynamicTableDateGroup2 == null || this.newManualInput.dynamicTableDateGroup2 == undefined ? null :
			formatDate(this.newManualInput.dynamicTableDateGroup2, "yyyy-MM-dd HH:mm:ss", this.localID));
		this.manualInputDynamicTablePramsData.dynamicTableDateGroup3 = (this.newManualInput.dynamicTableDateGroup3 == null || this.newManualInput.dynamicTableDateGroup3 == undefined ? null :
			formatDate(this.newManualInput.dynamicTableDateGroup3, "yyyy-MM-dd HH:mm:ss", this.localID));
		this.manualInputDynamicTablePramsData.dynamicTableDateGroup4 = (this.newManualInput.dynamicTableDateGroup4 == null || this.newManualInput.dynamicTableDateGroup4 == undefined ? null :
			formatDate(this.newManualInput.dynamicTableDateGroup4, "yyyy-MM-dd HH:mm:ss", this.localID));
		this.manualInputDynamicTablePramsData.dynamicTableDateGroup5 = (this.newManualInput.dynamicTableDateGroup5 == null || this.newManualInput.dynamicTableDateGroup5 == undefined ? null :
			formatDate(this.newManualInput.dynamicTableDateGroup5, "yyyy-MM-dd HH:mm:ss", this.localID));
		this.manualInputDynamicTablePramsData.dynamicTableDateGroup6 = (this.newManualInput.dynamicTableDateGroup6 == null || this.newManualInput.dynamicTableDateGroup6 == undefined ? null :
			formatDate(this.newManualInput.dynamicTableDateGroup6, "yyyy-MM-dd HH:mm:ss", this.localID));


		this.manualInputService.addManualInput(this.manualInputDynamicTablePramsData).subscribe(result => {

			if (result === 1) {
				this.showAddNewPopup = false;
				this.newManualInput = new ManualInputDynamicTable();
				this.loadPageInfo();
			} else {
				this.infoPopupMessage = 'This combination already exists in table.';
				this.infPopupTitle = 'Warning';
				this.showInfoPopup = true;
				this.newManualInput = new ManualInputDynamicTable();
				this.loadPageInfo();
				setTimeout(() => {
					this.showInfoPopup = false;
				}, 3000);
			}
		});

	}

	createAddNewPopup() {
		this.showAddNewPopup = true;
		let AddNewPopupTitleData = this.valuesDataSource.find(x => x.dynamicTableId == this.currentlySelectedTableId);
		if (AddNewPopupTitleData != null && AddNewPopupTitleData.dynamicTableName != null) {
			this.addNewPopupTile = "Add New " + AddNewPopupTitleData.dynamicTableName;
		}
	}

	onToolbarPreparing(e) {
		const toolbarItems = e.toolbarOptions.items;


		toolbarItems.unshift({
			location: 'before',
			template: 'prevButtonTemplate'
		}, {
			location: 'before',
			template: 'expandButtonTemplate'
		},
			// {
			// 	location: 'before',
			// 	template: 'heightButtonTemplate'
			// }, 
			{
				location: 'after',
				template: 'appliedFiltersButtonTemplate'
			}, {
			location: 'before',
			template: 'leftSideData'
		}
		);

		const searchPanel = toolbarItems.filter(item => item.name === 'searchPanel');

		if (searchPanel && searchPanel[0]) {
			searchPanel[0].location = 'before';
		}
	}

	onExporting(event) {
		event.cancel = true;
	}

	fileName = "";
	exportExcel() {
		let data = new DyanmicInputUpdate();
		data.id = this.currentlySelectedTableId;

		this.manualInputService.exportExcel(data).subscribe(resultFilename => {

			if (resultFilename.flag == 1) {
				this.fileDownloadData.FileName = resultFilename.msg;
				this.fileDownloadData.LinkType = 1;
				this.fileName = resultFilename.retrunData;
				this.manualInputService.DownloadFile(this.fileDownloadData).subscribe(result => {
					const blob = new Blob([result], { type: EXCEL_TYPE });
					FileSaver.saveAs(blob, this.fileName + '.xlsx');

				}, error => { },
					() => console.info('File downloaded successfully'));
			}
			else {
				AppDevNotifyComponent.ErrorMessage("Sorry, something went wrong. Please try after some time again.");
			}

		}, error => { }
		);
	}


	numToAlpha(num) {
		let alpha = '';
		for (; num >= 0; num = parseInt((num / 26).toString(), 10) - 1) {
			alpha = String.fromCharCode(num % 26 + 0x41) + alpha;
		}
		return alpha;
	}

	fileDownloadData: FilePathCollection = new FilePathCollection();
	downLoadFile() {

		this.fileDownloadData.FileName = this.dynExcelParam.fileName;
		this.fileDownloadData.LinkType = 1;
		this.manualInputService.DownloadFile(this.fileDownloadData).subscribe(result => {
			const blob = new Blob([result], { type: EXCEL_TYPE });
			FileSaver.saveAs(blob, this.dynExcelParam.fileName);

		}, error => { },
			() => console.info('File downloaded successfully'));
	}


	@ViewChild('fileUploader', { static: false }) dxfileUploader1: DxFileUploaderComponent;
	errorLst: ErrorList[];
	fileValid: number = -1;


	uploadBeforeupload() {

	}

	uploadChunk(file) {

		this.fileValid = -1;
		this.errorLst = [];
		setTimeout(() => {
			this.dxfileUploader1.resetOptions();
			this.dxfileUploader1.value = [];
		}, 1000);

		if (file != null && file.request != null && file.request.response != null)
			var data = JSON.parse(file.request.response);
		if (data.fileName != null) {
			this.dynExcelParam.headerCount = this.manualInputEditingDto.fields.length;
			this.dynExcelParam.headerData = this.manualInputEditingDto.fields;
			this.dynExcelParam.totalDataCount = this.manualInputEditingDto.values.length;
			this.dynExcelParam.fileName = data.fileName;
			this.dynExcelParam.validationStarting = this.dataValidationStarting;
			this.dynExcelParam.DynamicTableId = this.currentlySelectedTableId;
			this.manualInputService.ValidateManualInputs(this.dynExcelParam, this.IsManuallyTableEnableDatabaseValidation).subscribe(result => {
				this.fileValid = 1;
				if (result != null && result.length > 0) {

					result.forEach(element => {
						if (element.errorType == 4) {
							this.uniqueId = element.errorMessage;
							this.fileValid = 1;
						}
						else if (element.errorType != 3) {
							this.errorLst.push(element);
							this.fileValid = 0;
						}
						else if (element.errorType == 3) {
							this.fileValid = 1;
						}
					});
				}

			});
		}
	}

	uniqueId = "";
	onImportData() {
		this.infoPopupMessage = "";
		if (this.dynExcelParam != null && this.dynExcelParam.fileName != null && this.dynExcelParam.fileName != "") {

			this.dynExcelParam.uniqueId = this.uniqueId;
			this.manualInputService.UploadDynamicData(this.dynExcelParam, this.IsManuallyTableEnableDatabaseValidation).subscribe(result => {
				if (result != null && result.length > 0) {
					result.forEach(element => {
						if (element.errorType != 3) {
							this.errorLst.push(element);
							this.fileValid = 0;

						}
						else if (element.errorType == 3) {
							this.fileValid = -1;
							this.showInfoPopup = true;
							this.infPopupTitle = 'Uploaded';
							this.infoPopupMessage = element.errorMessage;
							this.loadPageInfo();
						}
					});
				}

			});
		} else {
			this.showInfoPopup = true;
			this.infPopupTitle = 'Error';
			this.infoPopupMessage = "something went wrong. please try again later.";
		}
	}

	showImportExport: boolean = false;
	showHideImportExport() {
		this.fileValid = -1;
		this.showImportExport = !this.showImportExport;
	}

	SelectDynamicTableHelpId(DynamicTableId: number) {
		this.manualInputService.SelectDynamicTableHelpId(DynamicTableId).subscribe(result => {
			this.dynamicHelpPageId = result[0].helpPageId;
		})
	}

	RowCountGroupTempl(data) {
		if (data != null && data != undefined && data.items != null && data.items != undefined
			&& data.items.length != null && data.items.length != undefined) {
			return data.items.length;
		}
		if (data != null && data != undefined && data.collapsedItems != null && data.collapsedItems != undefined
			&& data.collapsedItems.length != null && data.collapsedItems.length != undefined) {
			return data.collapsedItems.length;
		}
	}

	proceedingInfoPopup = false;
	DeleteDynamicTablePopup() {
		this.proceedingInfoPopup = true;
	}

	deleteSelectedInputs() {
		let deleteItem: ManualIds = { dynamicTableId: 0, Ids: { Id: [] } }
		deleteItem.dynamicTableId = this.currentlySelectedTableId;
		this.selectedInputs.forEach(element => {
			deleteItem.Ids.Id.push(element.id);
		});


		this.proceedingInfoPopup = false;
		this.manualInputService.deleteManualInputs(deleteItem).subscribe(result => {
			this.showInfoPopup = true;
			this.infoPopupMessage = 'Manual Input deleted successfully!';
			this.infPopupTitle = 'Deleted';


			setTimeout(() => {
				this.changeInfoPopupStatusFalse();
			}, 3000);

			this.loadPageInfo();
		});
	}
	isNumberFormat(field) {
		let IsNullFormat = null;
		if (field != null && field.dataFormat != null && field.dataFormat != "") {
			IsNullFormat = {
				format: field.dataFormat
			};
		}
		return IsNullFormat;
	}

	onEditorPreparing(e) {
		if (e.parentType === 'dataRow') {
			e.editorOptions.readOnly = !e.row.data.enableReadOnly;
		}
		if (e.parentType === 'dataRow' && e.dataField === 'selected') {
			if (e.row.data && e.row.data.enableDelete != undefined && e.row.data.enableDelete != null && !e.row.data.enableDelete) {
				e.editorOptions.disabled = !e.row.data.enableDelete;
			}
		}
	}

	onCheckNumberbox(e): boolean {
		if (e && e.row && e.row.data && e.row.data.enableReadOnly != undefined && e.row.data.enableReadOnly != null) {
			return !e.row.data.enableReadOnly;
		}
		return false;
	}

	loadDynamicCss(item) {
			let BackgroundColour = '', FontBold: boolean = false, RowHeight = '', FontSize = '', columnWidth = '', textAlignment = "";
			if (item.rowType === 'data' && this.manualInputEditingDto != null && this.manualInputEditingDto.fields != undefined && this.manualInputEditingDto.fields != null) {
				let fieldColumn = this.manualInputEditingDto.fields.find(x => x.field == item.column.name);
				if (fieldColumn != undefined && fieldColumn != null && fieldColumn.rowFormatOn != null && fieldColumn.rowFormatOn == true) {
					BackgroundColour = fieldColumn.backgroundColour ?? '';
					FontBold = fieldColumn.fontBold ?? false;
					//columnWidth = fieldColumn.columnWidth ?? '';
					FontSize = fieldColumn.fontSize ?? '';
				}
				
				let fieldRow = this.manualInputEditingDto.dynamicTableRow.find(x => this.compareValues(x.fromOperation, item.data[x.fieldName], x.fromValue)
					&& this.compareValues(x.toOperation, item.data[x.fieldName], x.toValue));
			
				if (fieldRow != undefined && fieldRow != null && fieldRow.formatOn != null && fieldRow.formatOn == true) {
					BackgroundColour = fieldRow.backgroundColour ?? '';
					FontBold = fieldRow.fontBold ?? false;
					RowHeight = fieldRow.rowHeight ?? '';
					FontSize = fieldRow.fontSize ?? '';
					textAlignment = fieldRow.textAlignment ?? '';
				}
			}

			let style = (BackgroundColour != '' ? "background-color:" + BackgroundColour + ' !important;' : '')
				+ ("font-weight:" + (FontBold ? 'bold' : 'normal') + ' !important;')
				+ (RowHeight != '' ? "height:" + RowHeight + 'px !important;' : '')
				+ (columnWidth != '' ? "width:" + columnWidth + 'px !important;' : '')
				+ (textAlignment != '' ? "text-align:" + textAlignment + ' !important;' : '')
				+ (FontSize != '' ? "font-size:" + FontSize + 'px !important;' : '');
			return style;
	}

	onSelectionChanged(e: any) {
		if (e && e.component && e.component.getSelectedRowKeys && e.component.getSelectedRowKeys()) {
			e.component.getSelectedRowKeys().forEach((key: any) => {
				if (key && key.enableDelete != undefined && key.enableDelete != null && !key.enableDelete) {
					e.component.deselectRows(key);
				}
			});
		}
	}

	//bookmark
	@ViewChild('bookmarksGroup', { static: false })
	public bookmarksGroup: BookmarkNewComponent;
	public bookmarkElementsOperators: BookmarkElementsOperator[];
	private _activatedRoute: ActivatedRoute = inject(ActivatedRoute);
	public async initializeBookmarks(SelectedTableId: number): Promise<Data> {
		let routeData: Data = await firstValueFrom(this._activatedRoute.data);
		this.bookmarkElementsOperators = [
			new DxDataGridBookmarkElementsOperator(
				UtilsService.computeRouteHash(routeData.id, DxDataGridBookmarkElementsOperator.DEFAULT_ID_PART * SelectedTableId).toString(),
				() => this.dataGrid
			)
		];

		return routeData;
	}

	@HostListener('window:resize', ['$event'])
	onResize(event: Event): void {
		this.setDynamicHeight();
	}

	tableHeight = 600;
	setDynamicHeight(): void {
		const windowHeight = window.innerHeight;
		let dynamicHeight = windowHeight * 0.8; // 90% of window height
		dynamicHeight = (dynamicHeight > 800 ? dynamicHeight : 800)
		const element = document.getElementById('dynamicHeightDiv');
		if (element) {
			element.style.height = dynamicHeight + 'px';
		}
		this.tableHeight = dynamicHeight;

	}

	compareValues(operation: string, first: any, second: any): boolean {
		
		if (second == null || first == null) {
			return true;
		}
		if (second == '' || first == '') {
			return true;
		}

		switch (operation) {
			case '':
				return first == second;
			case null:
				return first == second;
			case '==':
				return first == second;
			case '===':
				return first === second;
			case '!=':
				return first != second;
			case '!==':
				return first !== second;
			case '<':
				return first < second;
			case '<=':
				return first <= second;
			case '>':
				return first > second;
			case '>=':
				return first >= second;
			default:
				return false;
		}
	}
}
